<template>
  <div>
    <v-date-picker class="inline-block h-full" :masks="masks" v-bind="$props" v-model="valueDate" is-range ref="picker" v-bind:key="refreshKey" is24hr>
      <template v-slot="{ inputValue, inputEvents, isDragging }">
        <div class="date-picker-range-container d-flex align-items-center" :class="{'clearable':clearable}" style="width: 100%">
          <!-- Start Date -->
          <div class="d-inline-block" style="width: 100%">
            <div class="flex items-center">
              <b-input-group :size="size" v-on="inputEvents.start" >
                <template #prepend>
                  <b-input-group-text><i class="far fa-calendar-alt"></i></b-input-group-text>
                </template>
                <b-form-input class="text-center" type="text" v-bind:value="formattedTime.start" :placeholder="$t('filters.start')" readonly />
                <template #append v-if="clearable">
                  <b-input-group-text @click="clearInput"><i class="fa-solid fa-xmark"></i></b-input-group-text>
                </template>
              </b-input-group>
            </div>
          </div>
          <div class="date-picker-arrow"><i class="fa-solid fa-arrow-right"></i></div>
          <!-- End Date -->
          <div class="d-inline-block" style="width: 100%">
            <div class="flex items-center">
              <b-input-group :size="size" v-on="inputEvents.end">
                <template #prepend>
                  <b-input-group-text><i class="far fa-calendar-alt"></i></b-input-group-text>
                </template>
                <b-form-input class="text-center" type="text" v-bind:value="formattedTime.end" :placeholder="$t('filters.end')" readonly/>
                <template #append v-if="clearable">
                  <b-input-group-text @click="clearInput"><i class="fa-solid fa-xmark"></i></b-input-group-text>
                </template>
              </b-input-group>
            </div>
          </div>
        </div>
      </template>
      <template v-if="needFooter" v-slot:footer>
        <div
            class="picker-footer d-flex flex-wrap justify-content-center align-items-center border-t rounded-b-lg p-1"
            v-if="mode !== 'time'"
        >
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setThisWeek">
            {{ $t('filters.picker.thisWeek') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setLastWeek">
            {{ $t('filters.picker.lastWeek') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setThisMonth">
            {{ $t('filters.picker.thisMonth') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setLastMonth">
            {{ $t('filters.picker.lastMonth') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setDays(30)">
            {{ $t('filters.picker.last30Days') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setThisYear">
            {{ $t('filters.picker.thisYear') }}
          </b-button>
          <b-button variant="outline-primary" size="sm" class="footer-btn" @click="setToToday">
            {{ $t('filters.picker.today') }}
          </b-button>
        </div>
      </template>

    </v-date-picker>
  </div>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'

const convertToInput = function ($this, val){
  if(val == null){
    return {start: null, end: null};
  }
  if($this.mode !== 'date') {
    return {
      start: val.start != null ? $this.$moment(val.start, $this.i18nInputKey)
          .utc()
          .format($this.i18nInputKey) : null,
      end: val.end != null ? $this.$moment(val.end, $this.i18nInputKey)
          .utc()
          .format($this.i18nInputKey) : null
    }
  }else {
    return {
      start: val.start != null ? $this.$moment(val.start, $this.i18nInputKey)
          .format($this.i18nInputKey) : null,
      end: val.end != null ? $this.$moment(val.end, $this.i18nInputKey)
          .format($this.i18nInputKey) : null
    }
  }
}

export default {
  name: 'calendarPickerRange',
  mixins: [mixinBase],
  data: () => ({
    currentValue: { // Data in local timezone
      start: null,
      end: null
    },
    changes:0,
    masks: {
      L: 'yyyy-dd-MM',
      input: ['yyyy-dd-MM'],
      inputDateTime: ['yyyy-dd-MM HH:mm'],

      // ...optional `title`, `weekdays`, `navMonths`, etc
    }
  }),
  watch:{
    value:{
      handler(val){
        this.onValueChange(val);
      },
      deep:true
    }
  },
  props: {
    value: {
      required: true,
      default: () => null
    },
    mode: {
      required: false,
      default: () => 'date'
    },
    size: {
      required: false,
      default: () => 'sm'
    },
    needFooter: {
      required: false,
      default: () => true
    },
    minDate: {},
    maxDate: {},
    disabledDates: {},
    availableDates: {},
    clearable:{
      required: false,
      default: () => true
    }
  },
  mounted(){
    this.onValueChange(this.value);
  },
  computed: {
    valueDate: {
      get() {
        return this.currentValue;
      },
      set(val) {
        if(val == null){
          val = {start: null, end: null};
        }
        if (val.start != null) {
          val.start = this.$moment(val.start)
              .format(this.i18nInputKey)
        }
        if (val.end != null) {
          val.end = this.$moment(val.end)
              .format(this.i18nInputKey)
        }
        this.currentValue = {...val};
        //Convert to utc
        this.$emit('input', convertToInput(this, val));
      }
    },
    formattedTime() {
      // console.log('formattedTime', this.valueDate)
      let result = {
        start: '',
        end: ''
      }
      let startTime = this.$moment(this.valueDate.start, this.i18nInputKey)
      let endTime = this.$moment(this.valueDate.end, this.i18nInputKey)
      if (startTime.isValid()) {
        result.start = startTime.format(this.i18nFormatKey)
      }
      if (endTime.isValid()) {
        result.end = endTime.format(this.i18nFormatKey)
      }
      return result
    },
    i18nMaskKey() {
      return this.$t('timeFormat.' + this.mode + '.mask')
    },
    i18nFormatKey() {
      return this.$t('timeFormat.' + this.mode + '.format')
    },
    i18nInputKey() {
      return this.mode === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'
    },
  },
  methods: {
    onValueChange(val){
      // console.log("calendarPickerRange-> onValueChange", {val, currentVal: this.valueDate, i18nInputKey: this.i18nInputKey})
      let range = val ? {start: val.start, end: val.end} : {start: null, end: null};
      let hasChanged = false;
      if(range.start != null){
        if(this.$moment(range.start, this.i18nInputKey, true).isValid()) {
          range.start = this.$moment.server(range.start, this.i18nInputKey).format(this.i18nInputKey)
          hasChanged = range.start !== this.valueDate.start
          //console.log("picker start has change " + hasChanged, {currentVal: this.valueDate, newVal: val, i18nInputKey: this.i18nInputKey})
        }else {
          console.warn("Invalid start date format", {start: range.start, i18nInputKey: this.i18nInputKey})
        }
      }
      if(range.end != null){
        if(this.$moment(range.end, this.i18nInputKey, true).isValid()) {
          range.end = this.$moment.server(range.end, this.i18nInputKey).format(this.i18nInputKey)
          hasChanged = range.end !== this.valueDate.end
          //console.log("picker end has change " + hasChanged, {currentVal: this.valueDate, newVal: val, i18nInputKey: this.i18nInputKey})
        }else {
          console.warn("Invalid end date format", {end: range.end, i18nInputKey: this.i18nInputKey})
        }
      }
      if(this.changes > 10){
        console.warn("Changes reached max - preventing infinite loop")
        return
      }
      if(hasChanged){
        this.changes++;
        this.$emit('input', convertToInput(this, range));
        this.currentValue = range;
      }
    },
    setInput(val) {
      this.$emit('input', val)
    },
    clearInput() {
      this.currentValue = { start: null, end: null };
      if (this.$refs.picker) {
        this.$refs.picker.value = { start: null, end: null };
        this.$refs.picker.forceUpdateValue({ start: null, end: null });
      }
      this.$emit('input', { start: null, end: null });
      this.refreshKey = Date.now();
    },

    setToToday() {
      let valueDate = {
        start: this.$moment().startOf('day').format(this.i18nInputKey),
        end: this.$moment().endOf('day').format(this.i18nInputKey)
      }
      this.valueDate = valueDate;
      this.forceUpdateValue(valueDate);
      this.moveCalendar(valueDate);
    },
    setThisWeek() {
      const valueDate = {
        start: this.$moment().startOf('isoWeek').format(this.i18nInputKey),
        end: this.$moment().endOf('isoWeek').format(this.i18nInputKey)
      };

      this.valueDate = valueDate;
      this.forceUpdateValue(valueDate);
      this.moveCalendar(valueDate);
    },

    setLastWeek() {
      const valueDate = {
        start: this.$moment().subtract(1, 'isoWeek').startOf('isoWeek').format(this.i18nInputKey),
        end: this.$moment().subtract(1, 'isoWeek').endOf('isoWeek').format(this.i18nInputKey)
      };

      this.valueDate = valueDate;
      this.forceUpdateValue(valueDate);
      this.moveCalendar(valueDate);
    },
    setThisMonth(){
      let valueDate = {
        start: this.$moment().startOf('month').format(this.i18nInputKey),
        end: this.$moment().format(this.i18nInputKey)
      }
      this.valueDate = valueDate;
      this.forceUpdateValue(valueDate);
      this.moveCalendar(valueDate);
    },
    setLastMonth(){
      let valueDate = {
        start: this.$moment().subtract(1, 'month').startOf('month').format(this.i18nInputKey),
        end: this.$moment().subtract(1, 'month').endOf('month').format(this.i18nInputKey)
      }

      this.valueDate = valueDate;
      this.moveCalendar(valueDate);
      this.forceUpdateValue(valueDate);
    },
    setDays(days){
      let valueDate = {
        start: this.$moment().subtract(days, 'days').format(this.i18nInputKey),
        end: this.$moment().format(this.i18nInputKey)
      }
      this.valueDate = valueDate;
      this.moveCalendar(valueDate);
      this.forceUpdateValue(valueDate);
    },
    setThisYear(){
      let valueDate = {
        start: this.$moment().startOf('year').format(this.i18nInputKey),
        end: this.$moment().format(this.i18nInputKey)
      }
      this.valueDate = valueDate;
      this.moveCalendar(valueDate);
      this.forceUpdateValue(valueDate);
    },
    forceUpdateValue(valueDate){
      this.$refs.picker.forceUpdateValue(valueDate);
    },
    moveCalendar(valueDate){
      let moment = this.$moment(valueDate.start,this.i18nInputKey);
      let month = parseInt(moment.format("M"));
      let year = parseInt(moment.format("YYYY"));
      this.$refs.picker.move({ month, year });
    }
  }
}
</script>

<style lang="scss">
.date-picker-range-container {
  .date-picker-arrow {
    margin-right: 5px;
    margin-left: 5px;
  }
  .input-group {
    .input-group-prepend {
      .input-group-text {
        border-right: none !important;
        padding-right: 1px;
      }
    }
    input.form-control {
      border-left: none !important;
    }
  }
  &.clearable {
    .input-group-append{
      .input-group-text {
        padding-left: 1px;
        padding-right: 6px;
        cursor: pointer;
      }
    }
    input.form-control {
      border-left: none !important;
      border-right: none !important;
      padding: 0;
    }
  }
}

.picker-footer {
  background-color: #f9fafb;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;          /* 👈 tighter gap between buttons */
  padding: 0.25rem 0.5rem; /* less vertical padding */
}

.footer-btn {
  flex: 1 1 22%;          /* ~4 per row on wide screens */
  min-width: 50px;       /* smaller width */
  text-align: center;
  padding: 2px 6px !important; /* tighter padding inside the button */
  font-size: 0.75rem;     /* smaller text */
  line-height: 1.1;
  border-radius: 6px;     /* slightly rounded edges */
}

@media (max-width: 768px) {
  .footer-btn {
    flex: 1 1 45%;        /* 2 per row on mobile */
    min-width: 90px;
  }
}
.footer-btn {
  border-radius: 50px;
}

.footer-btn {
  border-color: rgba(100, 149, 237, 0.4); /* soft primary tone */
}


</style>
